import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';
import { featuredArticles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50 tracking-tight">
                Mulebuy<span className="text-accent-400">Spreadsheets</span>
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed max-w-xs">
              Your complete resource hub for Mulebuy Spreadsheet systems — guides, comparisons, and expert tutorials for smarter data management.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors">Home</Link></li>
              <li><Link to="/shopping-guide" className="text-sm text-background-300 hover:text-accent-400 transition-colors">Shopping Guide</Link></li>
              <li><Link to="/what-is-mulebuy-spreadsheet" className="text-sm text-background-300 hover:text-accent-400 transition-colors">Mulebuy Spreadsheet Guide</Link></li>
              <li><a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-accent-400 transition-colors">Main Platform</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <span className="text-sm text-accent-400">+ {categories.length - 6} more categories</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">Resources</h4>
            <ul className="space-y-2.5">
              {featuredArticles.slice(0, 6).map((article) => (
                <li key={article.seq}>
                  <Link to={article.slug} className="text-sm text-background-300 hover:text-accent-400 transition-colors line-clamp-1">
                    {article.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/shopping-guide" className="text-sm text-accent-400 hover:text-accent-300 transition-colors">
                  + {featuredArticles.length - 6} more articles
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} Mulebuy Spreadsheets. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-accent-400 transition-colors">
              Privacy
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-accent-400 transition-colors">
              Disclaimer
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}